import React from "react";
import styled from "styled-components";
import { AsurionDoodleSpinner } from "@trailhead/asurion-ui";

const LoadingContainer = styled.div`
  display: flex;
  position: relative;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 50vh;
  align-self: center;
  padding: 20px;
`;

export const Loader = () => (
  <LoadingContainer>
    <AsurionDoodleSpinner width="60px" />
  </LoadingContainer>
);
